import React, { useEffect, useMemo, useRef } from 'react';
import CommonTable, { TableRef } from '../../commonTable/CommonTable';
import { DefaultRoutingConfiguration } from '../../../types/routingConfiguration';

type Props = {
    conflicts: DefaultRoutingConfiguration[];
    callbackCloseModal: () => any;
};

const ModalShowRoutingAssignmentConflicts: React.FC<Props> = ({
    conflicts,
    callbackCloseModal
}) => {

    // #region State and Refs
    const commonTableRef = useRef<TableRef>(null);
    // #endregion

    // #region Memo
    const containerStyle = useMemo(() => ({ width: '100%', height: '100%' }), []);

    const columnDefs: any = useMemo(() => [
        {
            field: "customerCode",
            headerName: "CUSTOMER CODE"
        },
        {
            field: "businessFlow",
            headerName: "BUSINESS FLOW"
        },
        {
            field: "originCountry",
            headerName: "ORIGIN COUNTRY"
        },
        {
            field: "originZipCodeFrom",
            headerName: "ORIGIN POSTCODE FROM"
        },
        {
            field: "originZipCodeTo",
            headerName: "ORIGIN POSTCODE TO"
        },
        {
            field: "destinationCountry",
            headerName: "DESTINATION COUNTRY"
        },
        {
            field: "destinationZipCodeFrom",
            headerName: "DESTINATION POSTCODE FROM"
        },
        {
            field: "destinationZipCodeTo",
            headerName: "DESTINATION POSTCODE TO"
        },
        {
            field: "deposit1",
            headerName: "1ST DEPOT",
            cellRenderer: (props: { data: DefaultRoutingConfiguration }) => {
                let selectedValue = (!!props.data.route ? props.data.route[0] : "");
                return (
                    <div className="flex items-center">
                        <div>
                            {selectedValue}
                        </div>
                    </div>
                )
            }
        },
        {
            field: "deposit2",
            headerName: "2ND DEPOT",
            cellRenderer: (props: { data: DefaultRoutingConfiguration }) => {
                let selectedValue = (!!props.data.route ? props.data.route[1] : "");
                return (
                    <div className="flex items-center">
                        <div>
                            {selectedValue}
                        </div>
                    </div>
                )
            }
        }
    ], []);
    // #endregion

    // #region Util Functions
    
    // #endregion

    // #region Use Effects
    useEffect(() => {
        let insertionRow: any = conflicts.find((x: any) => x.rowId === -1);
        if (!!insertionRow) {
            insertionRow.isHighligthed = true;
        }

        commonTableRef.current?.setTableDataState(conflicts);
    }, [conflicts]);
    // #endregion

    return (
        <div style={{ zIndex: 9999 }} className="fixed top-0 left-0 h-screen w-screen bg-[#00000080] flex items-center justify-center">
            <div className="bg-white max-h-[75%] w-[95%] lg:w-[80%] max-w-[1920px] flex flex-col">
                <div className="shrink-0 flex justify-between border-b p-[30px]">
                    <div className="text-lg font-bold">
                        Conflict rows
                    </div>
                    <div onClick={callbackCloseModal} className="cursor-pointer">
                        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={2} stroke="currentColor" className="w-8 h-8">
                            <path strokeLinecap="round" strokeLinejoin="round" d="M6 18L18 6M6 6l12 12" />
                        </svg>
                    </div>
                </div>

                {/* MAIN CONTENT */}
                <div className="grow py-8 px-[30px] select-none overflow-auto relative">
                    <div className="mt-5" style={containerStyle}>
                        <CommonTable
                            ref={commonTableRef}
                            columnDefs={columnDefs}
                            options={{
                                showRowsNumber: false,
                                filter: false,
                                floatingFilter: false,
                                editable: false,
                                pageSize: 10
                            }}
                        />
                    </div>
                </div>
            </div>
        </div>
    )
};

export default ModalShowRoutingAssignmentConflicts;